<!-- eslint-disable vue/multi-word-component-names -->
<script lang="ts" setup>
import { useDark } from '@vueuse/core'
import { computed } from 'vue'

const properties = withDefaults(defineProps<{ size?: number; dark?: boolean }>(), {
  dark: undefined,
  size: undefined,
})

defineOptions({ inheritAttrs: false })

const isThemeDark = useDark({
  valueDark: 'dark',
  valueLight: 'light',
})

const isDark = computed(() => properties.dark ?? isThemeDark.value)

const color = computed(() => (isDark.value ? '#FFFFFF' : '#000000'))
</script>

<template>
  <svg :fill="color" :height="size ? `${size}px` : '100%'" viewBox="0 0 137 28" width="100%" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4794_3888)">
      <path
        clip-rule="evenodd"
        d="M15.0053 0C14.6379 0 14.2855 0.140476 14.0257 0.390526L0.405752 13.4994C0.145953 13.7494 0 14.0885 0 14.4422V26.4464C0 27.1828 0.62023 27.7797 1.38532 27.7797H13.8577C14.2251 27.7797 14.5774 27.6393 14.8372 27.3892L28.8629 13.8899V1.33333C28.8629 0.596953 28.2427 0 27.4776 0H15.0053ZM41.9093 13.8893L28.8629 13.8899L28.8631 26.4458C28.8631 27.1823 29.4832 27.7793 30.2483 27.7793H41.9093C42.6741 27.7793 43.2945 27.1821 43.2945 26.4458V15.2227C43.2945 14.4863 42.6741 13.8893 41.9093 13.8893Z"
        :fill="color"
        fill-rule="evenodd"
      />
      <path
        d="M65.4965 27.4645L64.0803 23.5473H55.4675L54.0513 27.4645H50.4385L57.7796 8.01758H61.7681L69.0803 27.4645H65.4965ZM56.5658 20.5469H62.982L59.7739 11.768L56.5658 20.5469Z"
        :fill="color"
      />
      <path
        d="M78.5527 16.4629H74.9688V23.1304C74.9688 23.7046 75.1038 24.1213 75.3734 24.3806C75.6431 24.6214 76.0382 24.7603 76.5584 24.7973C77.098 24.8159 77.7628 24.8065 78.5527 24.7695V27.4643C76.1634 27.7421 74.4486 27.5476 73.4081 26.8809C72.3676 26.1955 71.8474 24.9454 71.8474 23.1304V16.4629H69.1884V13.5737H71.8474V8.96875H74.9688V13.5737H78.5527V16.4629Z"
        :fill="color"
      />
      <path
        d="M92.2363 13.574H95.3577V27.4647H92.2363V25.4644C91.0608 27.0388 89.375 27.8258 87.1784 27.8258C85.1937 27.8258 83.4981 27.1221 82.0917 25.7145C80.685 24.2884 79.9818 22.5566 79.9818 20.5194C79.9818 18.4635 80.685 16.7319 82.0917 15.3243C83.4981 13.9167 85.1937 13.2129 87.1784 13.2129C89.375 13.2129 91.0608 13.9908 92.2363 15.5465V13.574ZM84.4038 23.7142C85.2709 24.5476 86.3594 24.9644 87.6697 24.9644C88.9799 24.9644 90.0686 24.5476 90.9357 23.7142C91.8027 22.8622 92.2363 21.7973 92.2363 20.5194C92.2363 19.2414 91.8027 18.1857 90.9357 17.3523C90.0686 16.5003 88.9799 16.0744 87.6697 16.0744C86.3594 16.0744 85.2709 16.5003 84.4038 17.3523C83.5368 18.1857 83.1032 19.2414 83.1032 20.5194C83.1032 21.7973 83.5368 22.8622 84.4038 23.7142Z"
        :fill="color"
      />
      <path
        d="M107.175 13.2127C109.16 13.2127 110.855 13.9165 112.262 15.324C113.668 16.7316 114.372 18.4633 114.372 20.5191C114.372 22.5564 113.668 24.2882 112.262 25.7142C110.855 27.1219 109.16 27.8256 107.175 27.8256C104.979 27.8256 103.293 27.0385 102.117 25.4642V27.4645H98.9959V8.01758H102.117V15.5463C103.293 13.9905 104.979 13.2127 107.175 13.2127ZM103.418 23.714C104.285 24.5474 105.373 24.9641 106.684 24.9641C107.994 24.9641 109.083 24.5474 109.95 23.714C110.817 22.862 111.25 21.7971 111.25 20.5191C111.25 19.2412 110.817 18.1855 109.95 17.3521C109.083 16.5001 107.994 16.0741 106.684 16.0741C105.373 16.0741 104.285 16.5001 103.418 17.3521C102.551 18.1855 102.117 19.2412 102.117 20.5191C102.117 21.7971 102.551 22.862 103.418 23.714Z"
        :fill="color"
      />
      <path
        d="M120.149 10.9344C119.763 11.3048 119.301 11.4901 118.761 11.4901C118.222 11.4901 117.75 11.3048 117.345 10.9344C116.96 10.5455 116.767 10.0917 116.767 9.57316C116.767 9.05457 116.96 8.61007 117.345 8.23966C117.731 7.85072 118.203 7.65625 118.761 7.65625C119.32 7.65625 119.792 7.85072 120.178 8.23966C120.563 8.61007 120.756 9.05457 120.756 9.57316C120.756 10.0917 120.553 10.5455 120.149 10.9344ZM117.201 27.4643V13.5737H120.322V27.4643H117.201Z"
        :fill="color"
      />
      <path
        d="M136.865 27.4648H133.253L129.669 22.7143L126.056 27.4648H122.414L127.848 20.3251L122.704 13.5742H126.316L129.64 17.9637L132.964 13.5742H136.605L131.461 20.3528L136.865 27.4648Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_4794_3888">
        <rect :fill="color" height="28" width="137" />
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="scss">
/* stylelint-disable block-no-empty */
.atabix-logo {
  @apply bg-foreground;
}
</style>
